<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-head"><a id="page_6"></a><a id="page_7"></a>Contents</h1>
<h2 class="toc"><a href="#/xhtml/07_Chapter01#ch1"><span>DROUGHT</span></a></h2>
<h2 class="toc"><a href="#/xhtml/08_Chapter02#ch2"><span>PANAMA GOLD</span></a></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter03#ch3" title="Link target outside of Sample"><span>THE YELLOW ONE</span></span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter04#ch4" title="Link target outside of Sample"><span>THE WHARF RATS</span></span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter05#ch5" title="Link target outside of Sample"><span>THE PALM PORCH</span></span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter06#ch6" title="Link target outside of Sample"><span>SUBJECTION</span></span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter07#ch7" title="Link target outside of Sample"><span>THE BLACK PIN</span></span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter08#ch8" title="Link target outside of Sample"><span>THE WHITE SNAKE</span></span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter09#ch9" title="Link target outside of Sample"><span>THE VAMPIRE BAT</span></span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter10#ch10" title="Link target outside of Sample"><span>TROPIC DEATH</span></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?27593cc9